// extracted by mini-css-extract-plugin
export default {"rating":"mB-z","numberOfStars":"nB-z","count":"oB-z","barGraphSpacing":"pB-z","barGraph":"qB-z"};